var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGeoSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 5.6a2.4 2.4 0 100 4.8 2.4 2.4 0 000-4.8zm0 3.911A1.511 1.511 0 118 6.49 1.511 1.511 0 018 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.556 7.556h-2.242a5.333 5.333 0 00-4.87-4.87V.444a.444.444 0 10-.888 0v2.242a5.333 5.333 0 00-4.87 4.87H.444a.444.444 0 100 .888h2.242a5.333 5.333 0 004.87 4.87v2.242a.444.444 0 00.888 0v-2.242a5.333 5.333 0 004.87-4.87h2.242a.444.444 0 000-.888zM8.444 12.42v-.688a.444.444 0 10-.888 0v.688a4.444 4.444 0 01-3.977-3.977h.688a.444.444 0 100-.888h-.688a4.444 4.444 0 013.977-3.977v.688a.444.444 0 10.888 0v-.688a4.444 4.444 0 013.977 3.977h-.688a.444.444 0 100 .888h.688a4.444 4.444 0 01-3.977 3.977z"
  }))));
}

export default SvgGeoSearch;